"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.safeJsonParse = void 0;
const safeJsonParse = (v) => {
    try {
        return JSON.parse(v);
    }
    catch (e) {
        return undefined;
    }
};
exports.safeJsonParse = safeJsonParse;
//# sourceMappingURL=json_utils.js.map